import styled from 'styled-components';

const Fieldset = styled.fieldset`
  border-width: 0;
`;

export { Fieldset };
export default Fieldset;
